/*
 * Céla — l'article s'envole vers le panier.
 * Au clic sur « Ajouter au panier » (fiche produit, barre fixe, fiche express, cartes produit)
 * ou sur « Acheter avec Shop Pay », la photo sort du cadre dans une pastille blanche,
 * suit une courbe jusqu'à l'icône panier, qui l'attrape avec un petit rebond et affiche le nouveau total.
 * Tout est animé en transform / opacity : fluide, calculé par la carte graphique.
 */
(function () {
  'use strict';
  if (window.CelaFly) return;

  var reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var EASE = 'cubic-bezier(.22, 1, .36, 1)';
  var FLIGHT = 1050;
  var POP = 0.17;
  var Z = 2147482600;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function easeInOutCubic(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function visibleArea(el) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return 0;
    var w = Math.min(r.right, innerWidth) - Math.max(r.left, 0);
    var h = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
    return w > 0 && h > 0 ? w * h : 0;
  }

  function cartIcon() {
    var list = document.querySelectorAll('.header-actions__cart-icon, cart-icon');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return list[i];
    }
    return null;
  }

  function cartCount() {
    var el = document.querySelector('cart-icon [ref="cartBubbleCount"]');
    var n = el ? parseInt(el.textContent, 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  /* La photo la plus visible d'une zone (galerie produit, carte, barre fixe…) */
  function bestImage(scope) {
    var imgs = (scope || document).querySelectorAll('img');
    var best = null;
    var bestArea = 0;
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (!im.complete || !im.naturalWidth) continue;
      if (im.closest('header, footer, cart-drawer-component, .cela-fly')) continue;
      var a = visibleArea(im);
      if (a > bestArea) { best = im; bestArea = a; }
    }
    return bestArea > 400 ? best : null;
  }

  function imgSrc(el) {
    if (!el) return '';
    if (el.tagName === 'IMG') return el.currentSrc || el.src;
    var im = el.querySelector && el.querySelector('img');
    return im ? im.currentSrc || im.src : '';
  }

  function make(cls, parent) {
    var el = document.createElement('div');
    el.className = cls;
    (parent || document.body).appendChild(el);
    return el;
  }

  /* ---------- L'icône panier « attrape » l'article ---------- */
  var dock = null;

  function openDock(icon) {
    var r = icon.getBoundingClientRect();
    var size = 48;
    if (dock) {
      clearTimeout(dock.timer);
      clearTimeout(dock.goneTimer);
      dock.el.getAnimations().forEach(function (a) { a.cancel(); });
      dock.el.style.opacity = '1';
    } else {
      var el = make('cela-fly cela-fly__dock');
      el.setAttribute('aria-hidden', 'true');
      var ring = make('cela-fly__ring', el);
      var svg = icon.querySelector('svg');
      if (svg) el.appendChild(svg.cloneNode(true));
      var badge = make('cela-fly__badge', el);
      dock = { el: el, ring: ring, badge: badge };
      dock.el.animate(
        [
          { transform: 'scale(.55)', opacity: 0 },
          { transform: 'scale(1)', opacity: 1 }
        ],
        { duration: 360, easing: EASE, fill: 'both' }
      );
    }
    dock.el.style.cssText =
      'left:' + (r.left + r.width / 2 - size / 2) + 'px;top:' + (r.top + r.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;z-index:' + (Z + 1);
    var n = cartCount();
    dock.badge.textContent = n > 0 ? String(n) : '';
    dock.badge.style.opacity = n > 0 ? '1' : '0';
    return dock;
  }

  function catchInDock(count) {
    if (!dock) return;
    var d = dock;
    d.el.animate(
      [
        { transform: 'scale(1) rotate(0deg)' },
        { transform: 'scale(1.22) rotate(-7deg)', offset: 0.24 },
        { transform: 'scale(.92) rotate(5deg)', offset: 0.5 },
        { transform: 'scale(1.05) rotate(-2deg)', offset: 0.74 },
        { transform: 'scale(1) rotate(0deg)' }
      ],
      { duration: 640, easing: 'ease-out', composite: 'replace' }
    );
    d.ring.animate(
      [
        { transform: 'scale(.8)', opacity: 0.55 },
        { transform: 'scale(2.3)', opacity: 0 }
      ],
      { duration: 720, easing: 'cubic-bezier(.2,.7,.3,1)' }
    );
    if (count > 0) {
      d.badge.textContent = count > 99 ? '99+' : String(count);
      d.badge.style.opacity = '1';
      d.badge.animate(
        [
          { transform: 'scale(0)' },
          { transform: 'scale(1.35)', offset: 0.55 },
          { transform: 'scale(1)' }
        ],
        { duration: 460, easing: EASE, delay: 90 }
      );
    }
    d.timer = setTimeout(function () {
      var out = d.el.animate(
        [
          { transform: 'scale(1)', opacity: 1 },
          { transform: 'scale(.8)', opacity: 0 }
        ],
        { duration: 380, easing: 'ease-in', fill: 'forwards' }
      );
      function gone() {
        d.el.remove();
        if (dock === d) dock = null;
      }
      out.onfinish = gone;
      /* Onglet en arrière-plan : les animations ne préviennent pas de leur fin, on range quand même */
      d.goneTimer = setTimeout(gone, 450);
    }, 1150);
  }

  /* ---------- Le vol ---------- */
  /**
   * @param {Element} source - photo (ou cadre) d'où part l'article
   * @param {{src?: string, qty?: number, keepCount?: boolean, count?: number|Promise<number>}} [opts]
   * @returns {{landed: Promise<void>}}
   */
  function launch(source, opts) {
    opts = opts || {};
    var icon = cartIcon();
    var src = opts.src || imgSrc(source);
    if (!icon || !source || !src || !document.body.animate) return { landed: Promise.resolve() };

    var predicted = cartCount() + (opts.qty || 1);
    var known = null;
    if (opts.count && typeof opts.count.then === 'function') {
      opts.count.then(function (n) { known = n; }, function () { known = -1; });
    } else if (typeof opts.count === 'number') {
      known = opts.count;
    }

    var sr = source.getBoundingClientRect();
    var ir = icon.getBoundingClientRect();
    var ex = ir.left + ir.width / 2;
    var ey = ir.top + ir.height / 2;

    openDock(icon);

    if (reduced.matches) {
      return {
        landed: new Promise(function (resolve) {
          setTimeout(function () {
            catchInDock(opts.keepCount ? cartCount() : known > 0 ? known : predicted);
            resolve();
          }, 120);
        })
      };
    }

    var D = Math.round(clamp(Math.min(sr.width, sr.height) * 0.6, 92, 190));
    var sx = clamp(sr.left + sr.width / 2, D / 2 + 8, innerWidth - D / 2 - 8);
    var sy = clamp(sr.top + sr.height / 2, D / 2 + 8, innerHeight - D / 2 - 8);
    var cx = sx + (ex - sx) * 0.6;
    var cy = Math.max(-24, Math.min(sy, ey) - Math.max(110, Math.abs(ex - sx) * 0.2));
    var endScale = 24 / D;

    function point(t) {
      var u = 1 - t;
      return { x: u * u * sx + 2 * u * t * cx + t * t * ex, y: u * u * sy + 2 * u * t * cy + t * t * ey };
    }
    function tf(x, y, s, r) {
      return 'translate3d(' + (x - D / 2).toFixed(1) + 'px,' + (y - D / 2).toFixed(1) + 'px,0) rotate(' + r.toFixed(2) + 'deg) scale(' + s.toFixed(4) + ')';
    }

    /* Pastille blanche avec la photo */
    var bubble = make('cela-fly cela-fly__bubble');
    bubble.setAttribute('aria-hidden', 'true');
    bubble.style.cssText = 'width:' + D + 'px;height:' + D + 'px;z-index:' + (Z + 2);
    var im = document.createElement('img');
    im.alt = '';
    im.decoding = 'async';
    im.src = src;
    bubble.appendChild(im);

    var N = 30;
    var frames = [
      { offset: 0, transform: tf(sx, sy, 0.3, 0), opacity: 0 },
      { offset: POP * 0.62, transform: tf(sx, sy - 8, 1.07, 0), opacity: 1 },
      { offset: POP, transform: tf(sx, sy - 6, 1, 0), opacity: 1 }
    ];
    var path = [];
    for (var i = 1; i <= N; i++) {
      var t = i / N;
      var e = easeInOutCubic(t);
      var p = point(e);
      var s = 1 + (endScale - 1) * Math.pow(e, 1.25);
      var r = -9 * Math.sin(Math.PI * t);
      var o = t > 0.88 ? 1 - ((t - 0.88) / 0.12) * 0.9 : 1;
      path.push({ x: p.x, y: p.y, t: t });
      frames.push({ offset: POP + (1 - POP) * t, transform: tf(p.x, p.y - 6 * (1 - t), s, r), opacity: o });
    }
    var anim = bubble.animate(frames, { duration: FLIGHT, easing: 'linear', fill: 'forwards' });

    /* Petite traînée de points (sauge, rose, sable) */
    var colors = ['#7e9077', '#c99a92', '#d9c6a0'];
    colors.forEach(function (color, k) {
      var dot = make('cela-fly cela-fly__dot');
      dot.style.cssText = 'background:' + color + ';z-index:' + (Z + 1);
      var df = path.map(function (pt) {
        return {
          offset: pt.t,
          transform: 'translate3d(' + (pt.x - 4).toFixed(1) + 'px,' + (pt.y - 4).toFixed(1) + 'px,0) scale(' + (1 - 0.6 * pt.t).toFixed(3) + ')',
          opacity: pt.t < 0.1 ? pt.t * 8 : 0.85 * (1 - pt.t)
        };
      });
      df.unshift({ offset: 0, transform: 'translate3d(' + (sx - 4).toFixed(1) + 'px,' + (sy - 4).toFixed(1) + 'px,0) scale(1)', opacity: 0 });
      var da = dot.animate(df, {
        duration: FLIGHT * (1 - POP),
        delay: FLIGHT * POP + 70 * (k + 1),
        easing: 'linear',
        fill: 'both'
      });
      da.onfinish = da.oncancel = function () { dot.remove(); };
      setTimeout(function () { dot.remove(); }, FLIGHT + 450);
    });

    var landed = new Promise(function (resolve) {
      var done = false;
      function land() {
        if (done) return;
        done = true;
        var finalCount = opts.keepCount ? cartCount() : known > 0 ? known : known === -1 ? cartCount() : predicted;
        catchInDock(finalCount);
        resolve();
      }
      setTimeout(land, FLIGHT * 0.95);
      anim.onfinish = function () {
        bubble.remove();
        land();
      };
      anim.oncancel = function () {
        bubble.remove();
        land();
      };
      setTimeout(function () { bubble.remove(); }, FLIGHT + 250);
    });

    return { landed: landed };
  }

  window.CelaFly = { launch: launch, bestImage: bestImage };

  /* ---------- Boutons du thème : fiche produit, barre fixe, cartes, Shop Pay ---------- */
  var last = 0;
  document.addEventListener(
    'click',
    function (e) {
      if (e.button !== 0 || e.defaultPrevented) return;
      var t = e.target;
      if (!t || !t.closest || t.closest('#CelaFx, cart-drawer-component, .cela-fly')) return;

      var btn = t.closest('add-to-cart-component button[type="submit"], button.add-to-cart-button[type="submit"]');
      var buy = null;
      if (!btn) {
        buy = t.closest('shopify-accelerated-checkout, .shopify-payment-button');
        if (buy && t.closest('.shopify-payment-button__more-options, #more-payment-options-link')) buy = null;
      }
      var el = btn || buy;
      if (!el) return;
      if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;

      var form = el.closest('form');
      if (!form) {
        var pf = el.closest('product-form-component');
        form = pf ? pf.querySelector('form') : null;
      }
      if (btn && form && typeof form.checkValidity === 'function' && !form.checkValidity()) return;

      var now = Date.now();
      if (now - last < 600) return;
      last = now;

      var scope = el.closest('product-card, quick-add-dialog, dialog, .shopify-section') || document;
      var source = bestImage(scope) || bestImage(document);
      var src = '';
      if (!source) {
        var comp = el.closest('add-to-cart-component');
        src = comp && comp.dataset.productVariantMedia ? comp.dataset.productVariantMedia.replace(/width=\d+/, 'width=400') : '';
        source = el;
      }

      var qty = 1;
      var qi = form ? form.querySelector('input[name="quantity"]') : null;
      if (qi && parseInt(qi.value, 10) > 0) qty = parseInt(qi.value, 10);

      /* Le nombre exact arrive avec la réponse du thème (événement cart:update) */
      var count = new Promise(function (resolve) {
        function onUpdate(ev) {
          document.removeEventListener('cart:update', onUpdate);
          var res = ev.detail && ev.detail.resource;
          var data = (ev.detail && ev.detail.data) || {};
          if (data.didError) resolve(-1);
          else if (res && typeof res.item_count === 'number') resolve(res.item_count);
          else resolve(cartCount() + qty);
        }
        document.addEventListener('cart:update', onUpdate);
        setTimeout(function () {
          document.removeEventListener('cart:update', onUpdate);
          resolve(cartCount() + qty);
        }, 4000);
      });

      launch(source, { src: src || imgSrc(source), qty: qty, keepCount: !!buy, count: buy ? undefined : count });
    },
    true
  );
})();